import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"items":_vm.items,"item-text":"nombre","item-value":"id","label":_vm.label,"persistent-hint":"","return-object":"","outlined":""},on:{"change":_vm.updateValue},model:{value:(_vm.valor_default),callback:function ($$v) {_vm.valor_default=$$v},expression:"valor_default"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }